import { render } from "./FooterWebsite.vue?vue&type=template&id=14c0e132"
import script from "./FooterWebsite.vue?vue&type=script&lang=js"
export * from "./FooterWebsite.vue?vue&type=script&lang=js"

import "./FooterWebsite.vue?vue&type=style&index=0&id=14c0e132&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__